import { Box, Container, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import SearchIcon from "../../assets/icons/SearchIcon";
import {
  getDocumentCheckList,
  updateDocumentCheckList,
} from "../../services/documentServices";
import DocumentListing from "./documentListing/DocumentList";

import "./getStarted.scss";
import SideBar from "./sideBar/SideBar";
import Footer from "../../components/discoverMore/Footer";
import { Link } from "react-router-dom";
const GetStarted = () => {
  const userId = localStorage.getItem("loggedInUserId");
  const { t } = useTranslation();
  const [documentCheckList, setDocumentCheckList] = useState([]);
  const [documentCheckListOriginal, setDocumentCheckListOriginal] = useState(
    []
  );
  const [searchKey, setSearchKey] = useState("");
  const [filterCount, setFilterCount] = useState(0);
  const [filtersValue, setFiltersValue] = useState("");
  const handleChangeCheckAll = (e) => {
    const updatedList = documentCheckList.map((elem) => ({
      ...elem,
      selected: e.target.checked,
    }));

    const payload = updatedList.map((elem) => {
      const { selected, userDocumentChecklistId } = elem;
      return {
        selected,
        userDocumentChecklistId,
      };
    });
    setDocumentCheckList(updatedList);
    mutateDocumentCheckList(payload);
  };
  const handleChangeCheck = async (e) => {
    const { userDocumentChecklistId, selected } = documentCheckList.find(
      (item) => item.userDocumentChecklistId == e.target.id
    );
    const payload = [
      {
        userDocumentChecklistId,
        selected: !selected,
      },
    ];
    const updatedList = documentCheckList.map((item) => {
      if (item.userDocumentChecklistId == e.target.id)
        return { ...item, selected: !item.selected };
      return item;
    });
    setDocumentCheckList(updatedList);
    setDocumentCheckListOriginal(updatedList);
    mutateDocumentCheckList(payload);
  };

  const mutateDocumentCheckList = async (payload) => {
    await updateDocumentCheckList(userId, payload);
  };

  const getCheckList = async (id) => {
    const result = await getDocumentCheckList(id);
    if (result.success) {
      setDocumentCheckList(result.payLoad);
      setDocumentCheckListOriginal(result.payLoad);
    }
  };
  const handleSearch = (e) => {
    setSearchKey(e.target.value);
    const result = documentCheckListOriginal?.filter((item) => {
      if (
        t(item?.documentNameKey)
          .toLowerCase()
          .match(e.target.value.toLowerCase())
      ) {
        return true;
      }
      return false;
    });
    setDocumentCheckList(result);
  };
  const checkSearchFilter = (searchValue) => {
    const result = documentCheckListOriginal?.filter((item) => {
      if (
        t(item?.documentNameKey).toLowerCase().match(searchValue.toLowerCase())
      ) {
        return true;
      }
      return false;
    });
    return result;
  };
  const handleFilter = (filters) => {
    let dataSet = documentCheckListOriginal;
    if (searchKey != "") {
      dataSet = checkSearchFilter(searchKey);
    }
    let filtersArray = filters.split(";");
    let result = dataSet?.filter((item) => {
      if (
        filtersArray != "" &&
        filtersArray.some((ai) =>
          [
            "cl-liquidity-plan",
            "cl-donations",
            "cl-your-wishes",
            "cl-assets",
            "cl-family-tree",
          ].includes(ai)
        )
      ) {
        if (
          filtersArray.includes(item?.relevantFeatureKey) ||
          (item.relevantFeatureKey.includes("cl-assets") &&
            filtersArray.includes("cl-assets"))
        ) {
          return true;
        }
        return false;
      } else {
        return true;
      }
    });
    result = result?.filter((item) => {
      if (
        filtersArray != "" &&
        filtersArray.some((ai) => ["cl-filling-form", "cl-upload"].includes(ai))
      ) {
        if (filtersArray.includes(item?.howToSubmitKey)) {
          return true;
        }
        return false;
      } else {
        return true;
      }
    });
    result = result?.filter((item) => {
      if (
        filtersArray != "" &&
        filtersArray.some((ai) => ["checked", "unChecked"].includes(ai))
      ) {
        if (
          (filtersArray.includes("checked") && item?.selected) ||
          (filtersArray.includes("unChecked") && !item?.selected)
        ) {
          return true;
        }
        return false;
      } else {
        return true;
      }
    });
    setFiltersValue(filtersArray);
    setFilterCount(filtersArray == "" ? 0 : filtersArray.length);
    setDocumentCheckList(result);
  };
  useEffect(() => {
    getCheckList(userId);
  }, []);
  return (
    <div className="main-container">
      <Container>
        <div className="content-section">
          <Typography variant="h4" fontWeight="bold">
            {t("what-will-i-need-to-get-started")}
          </Typography>
          <Typography width="34rem" textAlign="center" padding="10px 0">
            {t("get-started-sub-heading")}
          </Typography>
        </div>
        <Grid container spacing={2}>
          <Grid item xs={3} />
          <Grid item xs={9}>
            <div className="input-wrapper">
              <input
                placeholder={t("name-of-document-or-keyboard")}
                className="custom-input"
                value={searchKey}
                onChange={(e) => {
                  handleSearch(e);
                }}
              />
              <SearchIcon className="search-icon" onClick={() => {}} />
            </div>
          </Grid>
          <Grid item xs={3}>
            <SideBar handleDataFilter={handleFilter} count={filterCount} />
          </Grid>
          <Grid item xs={9}>
            <DocumentListing
              checkList={documentCheckList}
              handleChangeCheck={handleChangeCheck}
              handleChangeCheckAll={handleChangeCheckAll}
            />
          </Grid>
        </Grid>
        <div className="helper-content">
          <img src="/assets/images/helper.png" />
          <div>
            <Typography>{t("helping-content1")}</Typography>
            <br />
            <Typography>{t("helping-content2")}</Typography>
            <br />
            <Box className="get-starter-content" as="section">
              <p>
                {t("visit-faqs")}
                <Link
                  to={"/faq"}
                  key={1}
                  style={{
                    textDecoration: "none",
                  }}
                  target={"_blank"}
                >
                  <span>
                    <img src="/assets/icons/arrow_right_alt_FILL0_wght600_GRAD0_opsz48 (1).png" />
                  </span>
                </Link>
              </p>
            </Box>
          </div>
        </div>
      </Container>
      <Footer />
    </div>
  );
};

export default GetStarted;
